// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateRoleForm_create-role-form__ZQdjK .CreateRoleForm_roles__4qiOK {
  margin-top: 15px;
  height: 350px;
  overflow-y: scroll;
}
.CreateRoleForm_create-role-form__ZQdjK .CreateRoleForm_roles__4qiOK .CreateRoleForm_role__r43D- {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-right: 10px;
}
.CreateRoleForm_create-role-form__ZQdjK .CreateRoleForm_roles__4qiOK .CreateRoleForm_role__r43D- svg {
  width: 25px;
  height: 25px;
  cursor: pointer;
}
.CreateRoleForm_create-role-form__ZQdjK .CreateRoleForm_roles__4qiOK .CreateRoleForm_role__r43D- svg path {
  stroke-width: 0.5px;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/Pages/AccountCreate/Components/CreateRoleForm/CreateRoleForm.module.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;AAAJ;AACI;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AACN;AAEM;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAAR;AACQ;EACE,mBAAA;AACV","sourcesContent":[".create-role-form {\n  .roles {\n    margin-top: 15px;\n    height: 350px;\n    overflow-y: scroll;\n    .role {\n      margin-bottom: 10px;\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n      padding-right: 10px;\n      .permissions {\n      }\n      svg {\n        width: 25px;\n        height: 25px;\n        cursor: pointer;\n        path {\n          stroke-width: 0.5px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"create-role-form": `CreateRoleForm_create-role-form__ZQdjK`,
	"roles": `CreateRoleForm_roles__4qiOK`,
	"role": `CreateRoleForm_role__r43D-`
};
export default ___CSS_LOADER_EXPORT___;
